module.exports = __webpack_public_path__ + "static/media/Virtual-mirror-lens-4-psd_Fresh-Honey.e2d36ad2.png";